import styled from 'styled-components';

export const TableWrapper = styled.div`
  min-height: 100px;
  margin: 5px;
  height: 100%;
  position: relative;
  padding: 5px;
  background-color: #fff;

  .BaseTable__row.selected {
    background-color: #bddffb5c;
  }

  .BaseTable__row-cell-text {
    padding-left: 3px;
  }
`;

export const StyledRow = styled.div`
  border-left: 5px solid ${(props) => props.color};
  display: flex;
  flex-direction: row;
  height: 100%;
`;

export const StyledLinkButton = styled.div`
  display: flex;
  flex-direction: row;
  height: 100%;
  color: #4080e2;
  cursor: pointer;

  &:hover {
    color: #0945a2;
  }
`;

export const StyledCell = styled.div`
  ${(props) =>
    props.pctShare
      ? `background: linear-gradient(90deg, #BDDFFB ${props.pctShare}%, transparent ${props.pctShare}%, transparent ${100 - props.pctShare}%)`
      : 'none'};
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: background 2s ease-out;
`;
